<template>
  <div :class="{'content-block': !previewModeOnly}">
    <div
      v-if="!previewModeOnly"
      class="text-center"
    >
      <h2 class="mb-4">
        Latest Posts
      </h2>
      <p>
        Follow @Brooklyn on Instagram and use #Brooklyn to be<br>
        featured on our home page
      </p>
    </div>
    <vue-instagram
      :token="accessToken"
      :count="8"
      media-type="image"
      :tags="tags"
      class="d-flex flex-wrap"
      :class="{'instagram-widget': !previewModeOnly}"
    >
      <template #feeds="props">
        <v-flex
          sm3
          class="pa-3"
        >
          <div class="instagram-widget__item">
            <img
              :src="props.feed.images.standard_resolution.url"
              alt=""
            >
            <a
              class="instagram-widget__item-link"
              :href="props.feed.link"
              target="_blank"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.48871 0H14.4007C17.4274 0 19.8898 2.46235 19.8896 5.48882V14.4008C19.8896 17.4273 17.4274 19.8896 14.4007 19.8896H5.48871C2.46224 19.8896 0 17.4274 0 14.4008V5.48882C0 2.46235 2.46224 0 5.48871 0ZM14.4008 18.1249C16.4544 18.1249 18.1251 16.4544 18.1251 14.4008H18.1249V5.48882C18.1249 3.43541 16.4542 1.76471 14.4007 1.76471H5.48871C3.43529 1.76471 1.76471 3.43541 1.76471 5.48882V14.4008C1.76471 16.4544 3.43529 18.1251 5.48871 18.1249H14.4008Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.81982 9.94488C4.81982 7.11888 7.11888 4.81982 9.94488 4.81982C12.7709 4.81982 15.0699 7.11888 15.0699 9.94488C15.0699 12.7708 12.7709 15.0697 9.94488 15.0697C7.11888 15.0697 4.81982 12.7708 4.81982 9.94488ZM6.58453 9.94477C6.58453 11.7976 8.09206 13.3049 9.94488 13.3049C11.7977 13.3049 13.3052 11.7976 13.3052 9.94477C13.3052 8.09182 11.7978 6.58441 9.94488 6.58441C8.09194 6.58441 6.58453 8.09182 6.58453 9.94477Z"
                  fill="white"
                />
                <path
                  d="M15.2848 3.32373C14.9448 3.32373 14.6108 3.46138 14.3707 3.70255C14.1294 3.94255 13.9907 4.27667 13.9907 4.61785C13.9907 4.95797 14.1295 5.29197 14.3707 5.53314C14.6107 5.77314 14.9448 5.91197 15.2848 5.91197C15.626 5.91197 15.959 5.77314 16.2001 5.53314C16.4413 5.29197 16.579 4.95785 16.579 4.61785C16.579 4.27667 16.4413 3.94255 16.2001 3.70255C15.9601 3.46138 15.626 3.32373 15.2848 3.32373Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </v-flex>
      </template>
    </vue-instagram>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import VueInstagram from 'vue-instagram'

@Component({
  components: {
    VueInstagram,
  },
})
export default class InstagramWidget extends Vue {
  @Prop({ type: Boolean }) previewModeOnly!: boolean
  @Prop({ type: Array }) tags!: string[]
  @Prop({ type: String }) instagram_key!: string

  accessToken = '362555203.1677ed0.48d80658a060464898a1b65a7f650c6e'
}
</script>

<style lang="scss">
  .instagram-widget {
    margin: 1.875rem -0.75rem 0;

    &__item {
      border-radius: 2px;
      overflow: hidden;
      position: relative;
      height: 100%;
      width: 100%;

      img {
        display: block;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }

      &-link {
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 1;
        height: 3rem;
        width: 3rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>
